import GlobalDivider from '@/utils/divider/GlobalDivider';
import {
  AccountBookOutlined,
  PlusOutlined,
  RobotOutlined,
} from '@ant-design/icons';
import { Drawer, List, Typography } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
const { Title } = Typography;

const SideNavDrawer = ({ title, placement, closable, onClose, open }) => {
  const [selectedCreate, setSelectedCreate] = useState('purchase');

  const creates = {
    account: ['Ledger create', 'Group create'],
    inventory: ['Inventory group create', 'Inventory Item create'],
  };

  const createIcons = {
    account: (
      <AccountBookOutlined style={{ color: '#13f2f4', marginRight: '8px' }} />
    ),
    inventory: (
      <RobotOutlined style={{ color: '#faad14', marginRight: '8px' }} />
    ),
  };

  /**
   * Handles click event on report category.
   * @param {string} category - The selected category
   */
  const handleCategoryClick = (category) => {
    setSelectedCreate(category);
  };
  return (
    <div>
      <Drawer
        placement={placement}
        closable={closable}
        onClose={onClose}
        open={open}
        height={300}
      >
        <GlobalDivider name={title} />
        <List
          grid={{ gutter: 16, column: 3 }}
          dataSource={Object.keys(creates)}
          renderItem={(create) => (
            <List.Item>
              <div
                style={{
                  borderRadius: '2px',
                  padding: '10px',
                  cursor: 'pointer',
                }}
                onMouseEnter={() => handleCategoryClick(create)}
                onMouseLeave={() => handleCategoryClick(selectedCreate)}
              >
                <Title
                  level={5}
                  style={{
                    marginBottom: '20px',
                    color: '#636972',
                    fontSize: '16px',
                  }}
                >
                  {createIcons[create]}
                  {create === 'account'
                    ? 'Account'
                    : create.charAt(0).toLocaleUpperCase() + create.slice(1)}
                </Title>
                {creates[create].map((item) => (
                  <div
                    className=""
                    key={item}
                    style={{
                      marginBottom: '20px',
                      textDecoration: 'none',
                    }}
                  >
                    <Link
                      style={{
                        display: 'flex',
                        gap: '20px',
                      }}
                      className="report-list-item"
                      to={`/${item.toLowerCase().replace(/\s/g, '/')}/`}
                      onClick={onClose}
                    >
                      <PlusOutlined style={{ color: 'green' }} /> {item}
                    </Link>
                  </div>
                ))}
              </div>
            </List.Item>
          )}
        />
      </Drawer>
    </div>
  );
};

export default SideNavDrawer;
